var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGiftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0814 5.22592C20.8885 3.98636 18.6945 3.86178 17.4297 5.17609C16.8182 5.81144 16.3507 6.85791 16.0629 7.89814C16.015 8.65807 15.997 9.30589 16.003 9.87895C16.003 10.3524 16.009 10.4769 16.003 10.9379C17.2498 11.0749 20.349 11.2182 21.6078 9.9101C22.8726 8.59579 23.2743 6.47171 22.0814 5.23215V5.22592Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91864 5.22592C11.1115 3.98636 13.3055 3.86178 14.5703 5.17609C15.1818 5.81144 15.6493 6.85791 15.9371 7.89814C15.985 8.65807 16.003 9.30589 15.997 9.87895C15.997 10.3524 15.991 10.4769 15.997 10.9379C14.7502 11.0749 11.651 11.2182 10.3922 9.9101C9.13336 8.60201 8.72574 6.47171 9.91864 5.23215V5.22592Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9799 11.4114H4.02611C3.45337 11.4114 2.98907 11.8938 2.98907 12.489V17.3351C2.98907 17.9303 3.45337 18.4127 4.02611 18.4127H27.9799C28.5527 18.4127 29.017 17.9303 29.017 17.3351V12.489C29.017 11.8938 28.5527 11.4114 27.9799 11.4114Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5783 18.5808H4.42175V32.7517H27.5783V18.5808Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.997 11.3989V19.2287",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.997 19.2288V32.7518",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGiftWhite);
export default __webpack_public_path__ + "static/media/icon_gift_white.d7f2290f867119993aa8fef7518644df.svg";
export { ForwardRef as ReactComponent };